import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Tierliste } from '../../gruppe-tier/classes/tierliste';

export interface ListeAbschliessenStepperOpenOptions {
    /** `tiere` = continue scanning (default); `ausstallen` = jump to final Ausstallen step. */
    initialStep?: 'tiere' | 'ausstallen';
}

/** Opens the dashboard Ausstallen stepper prefilled for an open Abgangsliste (replaces legacy close modal). */
export interface ListeAbschliessenStepperHandler {
    open(tierliste: Tierliste, options?: ListeAbschliessenStepperOpenOptions): Observable<boolean>;
}

export const LISTE_ABSCHLIESSEN_STEPPER_HANDLER = new InjectionToken<ListeAbschliessenStepperHandler>(
    'LISTE_ABSCHLIESSEN_STEPPER_HANDLER',
);
